
import { Box, CircularProgress, Typography } from '@mui/material';
import { FC } from 'react';

import { lineSx, statLineTextSx } from './styles';

type Props = {
  count: number;
};

const PendingLine: FC<Props> = ({ count }) => {
  return (
    <Box sx={lineSx}>
      <CircularProgress size={20} />
      <Typography color='textSecondary' sx={statLineTextSx}>
        {count} processing
      </Typography>
    </Box>
  );
};

export default PendingLine;
